import fetch from '../utils/fetch';
import store from '@/vuex/index';
import { isProd } from '@/config';

/**
 *获取商品抵扣比例和首单资格
 *
 * @export
 * @returns
 */
export function vipMemberGetCurrentCreditRateInfo() {
  return fetch.get('/shopmember/api/creditRule/getShoppingCreditRule');
}

export function memberAuthBindingMobile(postData) {
  return fetch.post('/shopmember/api/alipay/memberAuth/bindingMobile', postData);
}

export function inviteVipRecordListMyInvitePageNew(postData) {
  return fetch.post('/soyoung/api/inviteVipRecord/listMyInvitePageNew', postData);
}

export function inviteVipAccountDetailListMyWithdrawPage(postData) {
  return fetch.post('/soyoung/api/inviteVipAccountDetail/listMyWithdrawPage', postData);
}

// 获取商品分享次数
export function soyoungCreditGetShareCommodityNum() {
  return fetch.get('/shopmember/api/credit/getShareCommodityNum');
}

export function soyoungCreditShareCommodity(commodityId = '') {
  const postData = {
    commodityId,
  };
  return fetch.post('/shopmember/api/credit/shareCommodity', postData);
}

// https://testgw.syounggroup.com/shopmember/api/memberAuth/bindingMobile
// {
// "id": "string",
// "mobile": "string",
//   "channel": "string",
//   "channelExtId": "string",
//   "channelNo": "string",
//   "city": "string",
//   "province": "string",
// }
export function memberExtImproveInfo(params) {
  return fetch.post('/shop-member-service/api/memberExt/improveInfo', params);
}

export function memberUpdate(postData) {
  return fetch.post('/shopmember/api/member/update', postData);
}

export function memberIdcardCreate(postData) {
  return fetch.post('/shopmember/api/memberIdcard/create', postData);
}

export function alipayMemberAuthUpdate(postData) {
  return fetch.post('/shopmember/api/alipay/memberAuth/update', postData);
}

export function memberIdcardUpdate(postData) {
  return fetch.post('/shopmember/api/memberIdcard/update', postData);
}

export function memberIdcardGet() {
  return fetch.get('/shopmember/api/memberIdcard/getForApp');
}

// API_MEMBER_SOURCE_CREATE
// activityId (string, optional):活动ID ,
// channel (string):渠道,APP-客户端，MINI_APPS-小程序，H5-网页 = ['APP', 'MINI_APPS', 'H5'],
// id (string):会员ID ,
// recommenderId (string, optional):推荐人ID ,
// source (string, optional):来源，LOTTERY-0元抽奖 = ['LOTTERY']
// 更新：['APP', 'MINI_APPS', 'WAP', 'TT_MINI_APPS', 'DY_MINI_APPS', 'MERCHANT_PC', 'TINYAPP', 'PUBLICAPP', 'OTHER', 'TEMPLATE_TINYAPP', 'ANDROID', 'IOS', 'QYWX']

export function memberSourceCreate(activityId = '', recommenderId = '', source = '') {
  const id = store.state.memberCO.id;
  let channel = 'MINI_APPS';

  channel = 'H5';















  const postData = {
    activityId,
    channel,
    id,
    recommenderId,
    source,
  };
  return fetch.post('/shopmember/api/memberSource/create', postData);
}

export function memberAuthRemoveBinding() {
  const memberId = store.state.memberCO.id || '';
  return fetch.post('/shopmember/api/memberAuth/removeBinding', {
    memberId,
    channel: 'WECHAT', // WECHAT-微信,WEIBO-微博,MP-公众号
  });
}

export function memberAuthReplaceMobile(newMobile, newMobileVerifyCode) {
  const memberId = store.state.memberCO.id || '';
  return fetch.post('/shopmember/api/memberAuth/replaceMobile', {
    memberId,
    newMobile,
    newMobileVerifyCode,
  });
}

export function memberAuthCancel() {
  const memberId = store.state.memberCO.id || '';
  return fetch.post(`/shopmember/api/memberAuth/cancel?memberId=${memberId}`);
}

export function memberAuthValidateCode(postData) {
  return fetch.post('/shopmember/api/memberAuth/validateCode', postData);
}

export function orderStatisticsGetStatisticsHot() {
  return fetch.get('/order/api/orderStatistics/getStatisticsHot');
}
// 更新生日
export function memberUpdateBirthDay(postData) {
  return fetch.post('/shop-member-service/api/member/updateBirthDay', postData);
}

// V3.21.1 获取是否领取支付宝会员卡
export function hasAlipayCardQuery(memberId = '') {
  return fetch.get(`/shopmember/api/memberApi/hasAlipayCard?memberId=${memberId}`);
}

// 获取会员等级和余额账户信息V2
export function getMemberCardInfoV2() {
  return fetch.get(`/shopmember/api/member/getMemberRightsCenterInfoV2`);
}

// 获得距离当前等级最近的会员权益内容
export function getClosestToCurrent(postData) {
  return fetch.post(`/shopmember/api/memberRights/getClosestToCurrent`, postData);
}

// 当游客（未登录）的情况访问会员中心，展示最低会员以及其权益、微页面
export function getVisitorLevelWithRights() {
  return fetch.get(`/shopmember/api/memberLevelConfig/getVisitorLevelWithRights`);
}

//  APP-获取当前店铺会员等级与权益
export function memberLevelConfigListForApp() {
  return fetch.get('/shopmember/api/memberLevelConfig/listForApp');
}

//  获取我的礼包信息：包含礼包数量和最近获取的礼包
export function shoppingCartPresentGetMyPresentHot() {
  return fetch.post('/order/api/shoppingCartPresent/getMyPresentHot');
}

/**
 *个人中心优惠券数量
 *
 * @export
 * @returns
 */
export function memberMarketingInfoGetMyBriefHot() {
  return fetch.get('/marketing/api/memberMarketingInfo/getMyBriefHot');
}

export function creditAccountGetMyAccount() {
  return fetch.get('/shopmember/api/credit/getMyCredit');
}

export function vipMemberRecordList(pageNo = 0, pageSize = 10, orderBy = 'update_date') {
  const postData = {
    data: {},
    pageNo,
    pageSize,
  };
  if (orderBy !== '') {
    postData.orderBy = orderBy;
  }
  return fetch.post('/soyoung/api/vipMemberRecord/list', postData);
}

export function vipMemberGet() {
  return fetch.get('/soyoung/api/vipMember/get');
}

// 我的羊币明细分页列表
// export function creditAccountDetailListMyPage(pageNo = 1, pageSize = 10, orderBy = 'update_date') {
//   const postData = {
//     data: {},
//     pageNo,
//     pageSize,
//   };
//   if (orderBy !== '') {
//     postData.orderBy = orderBy;
//   }
//   return fetch.post('/soyoung/api/creditAccountDetail/listMyPage', postData);
// }
// 我的羊币明细分页列表-会员等级调整接口变动
export function creditAccountDetailListMyPage(pageNo = 1, pageSize = 10, orderBy = 'update_date') {
  const postData = {
    data: {},
    pageNo,
    pageSize,
  };
  if (orderBy !== '') {
    postData.orderBy = orderBy;
  }
  return fetch.post('/shopmember/api/creditRecord/listMyRecordPage', postData);
}

// 余额兑换记录
// API_POST_GOODS_EXCHANGE_RECORD_LISTMINE
export function goodsExchangeRecordListMine(data) {
  return fetch.post('/creditmall/api/goodsExchangeRecord/listMine', data);
}

export function inviteVipAccountGet() {
  return fetch.get('/soyoung/api/inviteVipAccount/get');
}

export function inviteVipActivityGetPcpActivityInfoForInviter(activityId) {
  return fetch.get(
    `/soyoung/api/inviteVipActivity/getPcpActivityInfoForInviter?activityId=${activityId}`
  );
}

export function inviteVipAccountWithdrawAll() {
  return fetch.post('/soyoung/api/inviteVipAccount/withdrawAll');
}

export function inviteVipActivityGetPcpActivityInfoForInvitee(activityId, inviterId) {
  return fetch.get(
    `/soyoung/api/inviteVipActivity/getPcpActivityInfoForInvitee?activityId=${activityId}&inviterId=${inviterId}`
  );
}

export function inviteVipActivityGetActivityInfoForInvitee(activityId = '', inviterId = '') {
  return fetch.get(
    `/soyoung/api/inviteVipActivity/getActivityInfoForInvitee?activityId=${activityId}&inviterId=${inviterId}`
  );
}


export function memberSourceCreateOnlyH5(activityId, recommenderId, source) {
  const postData = {
    channel: 'WAP', // 渠道改成WAP
    id: store.state.memberCO.id,
  };
  if (activityId) postData.activityId = activityId;
  if (recommenderId) postData.recommenderId = recommenderId;
  if (source) postData.source = source;
  return fetch.post(
    `/shopmember/api/memberSource/create?X-User-Token=${store.state.token}`,
    postData
  );
}











export function inviteVipRecordListMyInviter() {
  return fetch.get('/soyoung/api/inviteVipRecord/listMyInviter');
}

export function memberAuthBindingMobileNew(id, mobile) {
  const wxUserInfo = uni.getStorageSync('wxUserInfo');
  const postData = {
    id,
    mobile,
    channel: 'WECHAT',
    // WECHAT-微信,WEIBO-微博,MP-公众号
    channelExtId: wxUserInfo.openId,
    channelNo: wxUserInfo.unionId,
    city: wxUserInfo.city,
    province: wxUserInfo.province,
  };
  return fetch.post('/shopmember/api/memberAuth/bindingMobileNew', postData);
}

export function memberAuthLoginByVerifyCode(mobile, code) {
  return fetch.post(
    `/shopmember/api/memberAuth/loginByVerifyCodeApp?mobile=${mobile}&verificationCode=${code}`
  );
}

/**
 * 这里接口做了环境判断，原因如下：
 * 测试环境做了兼容处理：如果当前支付宝绑定了别的手机，会先解绑，再绑定
 * 正式环境不兼容，如果当前支付宝绑定了别的手机，直接抛错
 */
export function alipayMemberAuthLoginByVerifyCode(mobile, code, authCode) {
  const url = isProd
    ? '/shopmember/api/alipay/memberAuth/loginByVerifyCode'
    : '/shopmember/api/token/alipay/loginByVerifyCode';
  return fetch.post(`${url}?mobile=${mobile}&verificationCode=${code}&code=${authCode}`);
}

// 微信公众号注册
export function wechatMemberAuthWxMpRegister(data) {
  return fetch.post(`/shopmember/api/wechat/memberAuth/wxMpRegister`, data);
}

export function wechatMemberAuthWxMpLogin(jsCode) {
  return fetch.post(`/shopmember/api/wechat/memberAuth/wxMpLogin?jsCode=${jsCode}`);
}

export function wechatMemberAuthWxLogin(postData) {
  const { openId } = store.state;
  postData.openid = openId;
  return fetch.post('/shopmember/api/wechat/memberAuth/wxLogin', postData);
}

export function createUserRiskRank() {
  return fetch.post('/shopmember/api/memberRiskRank/create');
}

// 支付宝小程序获取会员领卡链接
export function memberApiGetActivateUrlV2() {
  return fetch.get('/shopmember/api/memberApi/getActivateUrlV2');
}
// 获取生日权益详情数据
export function getMemberRightAndReceiveInfo(postData) {
  return fetch.post('/shopmember/api/memberRights/getMemberRightAndReceiveInfo', postData);
}

// 领取权益
export function drawRights(postData) {
  return fetch.post('/marketing-service/api/memberRights/drawRights', postData);
}

// 获取会员级弹窗数据
export function getMemberPopWindow(data) {
  return fetch.post('/soyoung/api/memberPopup/qryMemberPartPopup', data);
}

// 生日填写弹窗提交
export function updateBirthInfo(data) {
  return fetch.post('/shopmember/api/memberExt/improveInfo', data);
}

//  用户设置-获取渠道信息设置信息
export function memberGetUserChannelSetting() {
  return fetch.get('/shopmember/api/memberOption/getUserChannelSetting');
}

// 用户设置-更改渠道信息设置信息
export function memberChangeUserChannelSetting(postData) {
  return fetch.post('/shopmember/api/memberOption/changeUserChannelSetting', postData);
}
